import script from "./BgCenterToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./BgCenterToggle.vue?vue&type=script&setup=true&lang=js"

import "./BgCenterToggle.vue?vue&type=style&index=0&id=ca5d9c8c&scoped=true&lang=css"

import exportComponent from "/Users/kellyluo/Work/projects/icheer-web-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca5d9c8c"]])

export default __exports__